var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEigtheenYearsBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 80,
    viewBox: "0 0 93 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M41.294 59.6169L36.1791 46.3408C35.2987 44.06 33.2723 42.4193 30.8581 42.0414L16.8201 39.8375C14.4059 39.4597 11.9742 40.3973 10.4404 42.3003L1.51731 53.3724C-0.0164579 55.2755 -0.421737 57.8537 0.458697 60.1381L5.5736 73.4141C6.45403 75.695 8.48042 77.3357 10.8946 77.7135L24.9326 79.9175C27.3469 80.2953 29.7785 79.3577 31.3123 77.4547L40.2354 66.3826C41.7692 64.476 42.1745 61.8978 41.294 59.6169Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M77.7658 28.0416L63.5601 28.304C61.1179 28.3494 58.8854 29.6963 57.701 31.8372L50.8252 44.2877C49.6443 46.4286 49.6898 49.0383 50.951 51.1338L58.281 63.3219C59.5422 65.4174 61.8237 66.6802 64.2658 66.6348L78.4715 66.3724C80.9137 66.3269 83.1462 64.9801 84.3306 62.8391L91.2064 50.3887C92.3873 48.2477 92.3419 45.638 91.0806 43.5425L83.7506 31.3545C82.4894 29.259 80.208 27.9961 77.7658 28.0416Z",
    fill: "#4E8AC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M59.1474 9.52507L42.4925 0.782836C40.3298 -0.354109 37.7235 -0.245662 35.6587 1.0627L19.7724 11.1343C17.7076 12.4426 16.4988 14.755 16.5966 17.2003L17.3617 36.0106C17.4595 38.4559 18.8571 40.6599 21.0197 41.7968L37.6746 50.539C39.8372 51.676 42.4436 51.5676 44.5084 50.2592L60.3946 40.1876C62.4595 38.8792 63.6683 36.5669 63.5705 34.1216L62.8053 15.3112C62.704 12.8659 61.31 10.6585 59.1474 9.52507Z",
    fill: "#E5C868"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8073 33.7333V43.1193H32.6703V33.7333H24.7219V51.0779H66.7556V33.7333H58.8073Z",
    fill: "#6D6C6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7556 29.2798V33.7331H58.8073V29.2798C58.8073 22.0663 52.9447 16.1962 45.7405 16.1962C38.5363 16.1962 32.6738 22.0663 32.6738 29.2798V33.7331H24.7219V29.2798C24.7219 17.6759 34.1516 8.23755 45.7405 8.23755C57.3259 8.23755 66.7556 17.6759 66.7556 29.2798Z",
    fill: "#BCBCBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7407 35.2374V75.4747H22.3567C19.9495 75.4747 18 73.5227 18 71.1124V39.5997C18 37.1894 19.9495 35.2374 22.3567 35.2374H45.7407Z",
    fill: "#F4C660"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.474 39.5997V71.1124C73.474 73.5227 71.5245 75.4747 69.1173 75.4747H45.7369V66.638H50.8937L48.78 56.3496C50.6736 55.2406 51.9419 53.1836 51.9419 50.8328C51.9419 47.3624 49.1783 44.5358 45.7334 44.4449V35.2374H69.1138C71.5245 35.2374 73.474 37.1929 73.474 39.5997Z",
    fill: "#FF9F40"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7836 56.3495L50.8974 66.638H40.2378L42.3516 56.3495C40.4579 55.2405 39.1897 53.187 39.1897 50.8327C39.1897 47.3029 42.0476 44.4413 45.5693 44.4413C45.6287 44.4413 45.6846 44.4413 45.744 44.4448C49.1889 44.5357 51.9525 47.3624 51.9525 50.8327C51.9455 53.1835 50.6773 55.2405 48.7836 56.3495Z",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEigtheenYearsBlock);
export default __webpack_public_path__ + "static/media/EigtheenYearsBlock.600f93ae33705e8572c9f8ecf97f5748.svg";
export { ForwardRef as ReactComponent };